import { Store } from '@ngrx/store';
import { Observable, map, of } from 'rxjs';

import { OrderNotFoundError } from '../../../domain/errors/order-not-found.error';
import { OrderRepositoyInterface } from '../../../domain/ports/secondary/order-repository.interface';
import { selectOrdersOnline } from '../../../store/orders-type.selectors';

import { Order } from '@api/order/order.models';
import { ResultObject } from '@core/domain/types/result-object.type';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';

export function getOrderByIdUseCase(
    store: Store,
    orderRepository: OrderRepositoyInterface,
    orderId: number
): Observable<ResultObject<OrderNotFoundError, Partial<Order>>> {
    const onlineOrders = store.selectSignal(selectOrdersOnline)() ?? [];

    const found = onlineOrders.find((order) => +order.id === orderId);

    if (found) {
        return of({
            success: true,
            value: found,
        });
    }
    const { storeId, languageId } = store.selectSignal(getStoreAndLanguage)();

    return orderRepository.getOrderById(+storeId, +languageId, orderId).pipe(
        map((result) => {
            if (!result.success) {
                return {
                    success: false,
                    error: {
                        description: 'Order not found',
                    } as OrderNotFoundError,
                };
            }

            return result;
        }),
    );
}
